import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import Axios from "axios";

const routePrefix = "/infrastructuur/";

const InfrastructuurApi = {
	get(infrastructuurId) {
		const serviceUrl = prependRoot(routePrefix + infrastructuurId, getApiRoot());
		return Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	getAllByDossierId(dossierId) {
		const serviceUrl = prependRoot(routePrefix + "dossier/" + dossierId, getApiRoot());
		return Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	save(infrastructuur) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return Axios.put(serviceUrl, infrastructuur);
	},
	getSpakkiInfrastructuur(spakkiId) {
		const serviceUrl = prependRoot(routePrefix + "spakki/" + spakkiId, getApiRoot());
		return Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default InfrastructuurApi;
